import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";

import Home from './Pages/Home';
import About from './Pages/About';
import Header from './Component/Header';
import Customers from './Pages/Customers';
import AddCustomers from './Pages/AddCustomers';
import superadmin from './Pages/superadmin/superadmin';
import adminfaculty from './Pages/adminfaculty/adminfaculty';
import superadmininside from './Pages/superadmin/superadmininside';
import superadminstatus from './Pages/superadmin/superadminstatus';
import expert from './Pages/expert/expert';
import superadminaddress from './Pages/superadmin/superadminaddress';
import adminfacultyproportion from './Pages/adminfaculty/adminfacultyproportion';
import superadminlistregister from './Pages/superadmin/superadminlistregister';
import superadmincertificate from './Pages/superadmin/superadmincertificate';
import Homeuser from './Pages/Homeuser';
import Register from './Pages/Register';
import superadmincheckpayment from './Pages/superadmin/superadmincheckpayment';
import expertbn from './Pages/expert/expertbn';
import Homemain from './Pages/Homemain';
import Report from './Pages/Report';







//import Footter from './Component/Footter';

export default class Routes extends Component {
    render() {
        return (
            <Router basename="conference" >
                <Header />
                <br/>
                <Switch>
                    <Route exact path="/" component={Homemain} />
                    <Route exact path="/main" component={Home} />
                    <Route exact path="/About" component={About} />
                    <Route exact path="/Customers" component={Customers} />
                    <Route exact path="/AddCustomers" component={AddCustomers} />
                    <Route exact path="/superadmin" component={superadmin} />
                    <Route exact path="/adminfaculty" component={adminfaculty} />
                    <Route exact path="/superadmininside" component={superadmininside} />
                    <Route exact path="/superadminstatus" component={superadminstatus} />
                    <Route exact path="/superadminaddress" component={superadminaddress} />
                    <Route exact path="/expert" component={expert} />
                    <Route exact path="/adminfacultyproportion" component={adminfacultyproportion} />
                    <Route exact path="/superadminlistregister" component={superadminlistregister} />
                    <Route exact path="/superadmincertificate" component={superadmincertificate} />
                    <Route exact path="/Homeuser" component={Homeuser} />
                    <Route exact path="/Register" component={Register} />
                    <Route exact path="/superadmincheckpayment" component={superadmincheckpayment} />
                    <Route exact path="/expertbn" component={expertbn} />
                    <Route exact path="/Report" component={Report} />

                    <Route render={function () {return <h1>Not Found</h1> }} />
                </Switch> <br/>
               {/* <Footter /> */}
            </Router>
        )
    }
}
